type PinterestTagFunctions = ((fn: 'page') => void) &
  ((fn: 'load', id: string | number) => void) &
  ((fn: 'setconsent', consent: boolean) => void)

interface PinterestTagApi {
  pintrk: PinterestTagFunctions & {
    queue: any[]
    version: string
  }
}

declare global {
  interface Window extends PinterestTagApi {}
}

export const usePinterestTag = () => {
  const {
    public: { pinterestTagId },
  } = useRuntimeConfig()

  const { acceptedAnalytics } = useConsent()

  if (import.meta.client && !window.pintrk) {
    window.pintrk =
      window.pintrk ||
      function (...params: any[]) {
        ;(window.pintrk.queue = window.pintrk.queue || []).push(params)
      }
    window.pintrk.version = '3.0'
    window.pintrk('load', pinterestTagId)
  }

  return useScript(
    {
      src: 'https://s.pinimg.com/ct/core.js',
      crossorigin: false,
      async: true,
    },
    {
      trigger: acceptedAnalytics,
      use() {
        return {
          pintrk: window.pintrk,
        }
      },
    }
  )
}
